const prepareSelectData = <T>(
  data: T[],
  formatName?: (element: T) => string
) => {
  return data.map((element) => {
    return {
      name: formatName ? String(formatName(element)) : String(element),
      value: element,
    };
  });
};

export default prepareSelectData;
